import MessageCreatorActionTypes from '../types/message_creator';

const MessageCreatorReducer = function(/*state, action*/) {
  var defaultState = { disabled: false, height: 0 };
  var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
  var action = arguments[1];
  var store = Object.assign({}, state);

  switch (action.type) {
    case MessageCreatorActionTypes.DISABLE:
      store.disabled = true;
      delete store.errors;

      return store;
    case MessageCreatorActionTypes.ENABLE:
      store.disabled = false;
      delete store.errors;

      return store;
    case MessageCreatorActionTypes.ERROR:
      store.disabled = false;
      store.errors = action.errors.errors;

      return store;
    case MessageCreatorActionTypes.HEIGHT:
      store.height = action.height;

      return store;
  }

  return state;
};

export default MessageCreatorReducer;
